import { useState, useEffect } from "react";
import Variant from "./Variant";
import "./VariantGroups.scss";

const VariantGroups = (props) => {
    const { productVariants, setStyle, addToBasket, reduceFromBasket, isMultiVariant, fid, checkout, groupNavStyle } = props;
    const [activeGroup, setActiveGroup] = useState(0);

    // Static group definitions - will later come from JSON flags on variants
    const groups = [
        {
            title: "Digital",
            image: "https://placehold.co/500x300?text=Digital+Access",
            imageText: "Access on all your devices",
            features: [
                "Unrestricted access to abacusemedia.com",
                "Unlimited access to the E-paper & Abacus mobile app",
                "Access to the Abacus archive",
                "50% discount off Social and Personal announcements"
            ],
            variants: [
                {
                    productvariantid: 1001,
                    productvariantname: "Monthly",
                    price: "9.99",
                    title: "Monthly",
                    image: "https://placehold.co/600x400?text=Digital+Monthly",
                    originalPrice: "£15.99",
                    priceFrequency: "Per month",
                    offerEndText: "Offer ends in 10 days",
                    shortDescription: "Recurring monthly payment, cancel anytime",
                    badge: null,
                    highlighted: false,
                    features: [
                        "Unrestricted access to abacusemedia.com",
                        "Unlimited access to the E-paper & Abacus mobile app",
                        "Access to the Abacus archive"
                    ]
                },
                {
                    productvariantid: 1002,
                    productvariantname: "Annual",
                    price: "89.99",
                    title: "Annual",
                    image: "https://placehold.co/600x400?text=Digital+Annual",
                    originalPrice: "£120.00",
                    priceFrequency: "Per year",
                    offerEndText: "Offer ends in 5 days",
                    shortDescription: "Best value - save 25% vs monthly",
                    badge: "Best value",
                    highlighted: true,
                    features: [
                        "Unrestricted access to abacusemedia.com",
                        "Unlimited access to the E-paper & Abacus mobile app",
                        "Access to the Abacus archive",
                        "50% discount off Social and Personal announcements"
                    ]
                },
                {
                    productvariantid: 1003,
                    productvariantname: "2 Year",
                    price: "149.99",
                    title: "2 Year",
                    image: "https://placehold.co/600x400?text=Digital+2Year",
                    originalPrice: "£240.00",
                    priceFrequency: "Every 2 years",
                    offerEndText: "",
                    shortDescription: "Our longest plan at the lowest price",
                    badge: null,
                    highlighted: false,
                    features: [
                        "Unrestricted access to abacusemedia.com",
                        "Unlimited access to the E-paper & Abacus mobile app",
                        "Access to the Abacus archive",
                        "50% discount off Social and Personal announcements"
                    ]
                }
            ]
        },
        {
            title: "Print",
            image: "https://placehold.co/500x300?text=Print+Edition",
            imageText: "Delivered to your door",
            features: [
                "Weekly print edition delivered",
                "Access to the Abacus archive",
                "Exclusive print-only supplements",
                "50% discount off Social and Personal announcements"
            ],
            variants: [
                {
                    productvariantid: 2001,
                    productvariantname: "Monthly",
                    price: "14.99",
                    title: "Monthly",
                    image: "https://placehold.co/600x400?text=Print+Monthly",
                    originalPrice: "£20.00",
                    priceFrequency: "Per month",
                    offerEndText: "Offer ends in 10 days",
                    shortDescription: "Recurring monthly payment, cancel anytime",
                    badge: null,
                    highlighted: false,
                    features: [
                        "Weekly print edition delivered",
                        "Access to the Abacus archive",
                        "Exclusive print-only supplements"
                    ]
                },
                {
                    productvariantid: 2002,
                    productvariantname: "Annual",
                    price: "129.99",
                    title: "Annual",
                    image: "https://placehold.co/600x400?text=Print+Annual",
                    originalPrice: "£180.00",
                    priceFrequency: "Per year",
                    offerEndText: "Offer ends in 5 days",
                    shortDescription: "Save 28% vs monthly",
                    badge: "Most popular",
                    highlighted: true,
                    features: [
                        "Weekly print edition delivered",
                        "Access to the Abacus archive",
                        "Exclusive print-only supplements",
                        "50% discount off Social and Personal announcements"
                    ]
                }
            ]
        },
        {
            title: "Digital + Print",
            image: "https://placehold.co/500x300?text=Digital+%2B+Print",
            imageText: "The complete package",
            features: [
                "Unrestricted access to abacusemedia.com",
                "Unlimited access to the E-paper & Abacus mobile app",
                "Weekly print edition delivered",
                "Access to the Abacus archive",
                "Exclusive print-only supplements",
                "50% discount off Social and Personal announcements"
            ],
            variants: [
                {
                    productvariantid: 3001,
                    productvariantname: "Monthly",
                    price: "19.99",
                    title: "Monthly",
                    image: "https://placehold.co/600x400?text=Bundle+Monthly",
                    originalPrice: "£30.00",
                    priceFrequency: "Per month",
                    offerEndText: "Offer ends in 10 days",
                    shortDescription: "Recurring monthly payment, cancel anytime",
                    badge: null,
                    highlighted: false,
                    features: [
                        "Unrestricted access to abacusemedia.com",
                        "Weekly print edition delivered",
                        "Access to the Abacus archive"
                    ]
                },
                {
                    productvariantid: 3002,
                    productvariantname: "Annual",
                    price: "179.99",
                    title: "Annual",
                    image: "https://placehold.co/600x400?text=Bundle+Annual",
                    originalPrice: "£240.00",
                    priceFrequency: "Per year",
                    offerEndText: "Offer ends in 5 days",
                    shortDescription: "Best value bundle - save 25%",
                    badge: "Best value",
                    highlighted: true,
                    features: [
                        "Unrestricted access to abacusemedia.com",
                        "Unlimited access to the E-paper & Abacus mobile app",
                        "Weekly print edition delivered",
                        "Access to the Abacus archive",
                        "Exclusive print-only supplements",
                        "50% discount off Social and Personal announcements"
                    ]
                },
                {
                    productvariantid: 3003,
                    productvariantname: "2 Year",
                    price: "299.99",
                    title: "2 Year",
                    image: "https://placehold.co/600x400?text=Bundle+2Year",
                    originalPrice: "£480.00",
                    priceFrequency: "Every 2 years",
                    offerEndText: "",
                    shortDescription: "Ultimate savings on the complete package",
                    badge: null,
                    highlighted: false,
                    features: [
                        "Unrestricted access to abacusemedia.com",
                        "Unlimited access to the E-paper & Abacus mobile app",
                        "Weekly print edition delivered",
                        "Access to the Abacus archive",
                        "Exclusive print-only supplements",
                        "50% discount off Social and Personal announcements"
                    ]
                }
            ]
        }
    ];

    // Use static variants from the group definition
    const getVariantsForGroup = (groupIndex) => {
        return groups[groupIndex].variants;
    };

    const [varQuantity, setVarQuantity] = useState({});
    const [selectedVariant, setSelectedVariant] = useState(groups[0]?.variants[0]?.productvariantid || null);

    const selectVariant = (id) => setSelectedVariant(id);

    // Pre-select first variant when group changes
    useEffect(() => {
        const firstVariant = groups[activeGroup]?.variants[0]?.productvariantid;
        if (firstVariant) setSelectedVariant(firstVariant);
    }, [activeGroup]);

    // Initialize quantities for multi-variant mode (0 for list, 1 for card/pill)
    useEffect(() => {
        if (isMultiVariant) {
            const initial = {};
            groups[activeGroup]?.variants.forEach(v => { initial[v.productvariantid] = setStyle === "list" ? 0 : 1; });
            setVarQuantity(prev => {
                const hasValues = Object.values(prev).some(v => v > 0);
                if (hasValues && setStyle !== "list") return prev;
                return initial;
            });
        }
    }, [isMultiVariant, activeGroup, setStyle]);

    const incrementQuantity = (id) => {
        setVarQuantity((prev) => ({ ...prev, [id]: (prev[id] || 0) + 1 }));
        // TODO: call addToBasket(id) when using real variant IDs
    };

    const decreaseQuantity = (id) => {
        const currentQty = varQuantity[id] || 0;
        if (currentQty > 0) {
            setVarQuantity((prev) => ({ ...prev, [id]: currentQty - 1 }));
            // TODO: call reduceFromBasket(id, 1) when using real variant IDs
        }
    };

    const setQuantityForVariant = (id, newQuantity) => {
        const currentQty = varQuantity[id] || 0;
        setVarQuantity((prev) => ({ ...prev, [id]: newQuantity }));
        if (newQuantity > currentQty) {
            addToBasket(id, newQuantity - currentQty);
        } else if (newQuantity < currentQty) {
            reduceFromBasket(id, currentQty - newQuantity);
        }
    };

    const oneproductbuy = (id) => {
        setVarQuantity((prev) => ({ ...prev, [id]: 1 }));
        addToBasket(id);
        checkout(fid, true);
    };

    const activeGroupData = groups[activeGroup];
    const activeVariants = getVariantsForGroup(activeGroup);

    return (
        <div className="variant-groups">
            {groupNavStyle === "tabbed" ? (
                <>
                    {/* Tabbed navigation */}
                    <div className="variant-groups-tabs">
                        {groups.map((group, index) => (
                            <button
                                key={index}
                                className={`variant-groups-tab ${activeGroup === index ? "active" : ""}`}
                                onClick={() => setActiveGroup(index)}
                            >
                                {group.title}
                            </button>
                        ))}
                    </div>

                    {/* Single group content */}
                    <div className="variant-groups-content">
                        <div className={`variant-groups-info ${activeVariants.length > 1 ? "variant-groups-info--horizontal" : ""}`}>
                            <div className="variant-groups-image">
                                <img src={activeGroupData.image} alt={activeGroupData.title} />
                            </div>
                            <div className="variant-groups-features">
                                <h3>What's included</h3>
                                <ul>
                                    {activeGroupData.features.map((feature, i) => (
                                        <li key={i}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className={`item-container variant-groups-variants ${setStyle !== "pill" && setStyle !== "list" ? "flex-direction-row" : ""}`}>
                            {activeVariants.map((item, index) => (
                                <Variant
                                    key={index}
                                    variant={item.productvariantid}
                                    price={item?.price}
                                    description={item?.productvariantname}
                                    title={item?.title}
                                    image={item?.image}
                                    originalPrice={item?.originalPrice}
                                    priceFrequency={item?.priceFrequency}
                                    offerEndText={item?.offerEndText}
                                    shortDescription={item?.shortDescription}
                                    badge={item?.badge}
                                    highlighted={item?.highlighted}
                                    features={item?.features}
                                    setStyle={setStyle}
                                    incrementQuantity={incrementQuantity}
                                    decreaseQuantity={decreaseQuantity}
                                    oneproductbuy={oneproductbuy}
                                    setQuantityForVariant={setQuantityForVariant}
                                    varQuantity={varQuantity[item.productvariantid] || 0}
                                    addToBasket={addToBasket}
                                    isMultiVariant={setStyle === "list" ? isMultiVariant : false}
                                    isMultiVariantDropdown={setStyle !== "list" && isMultiVariant}
                                    selected={selectedVariant === item.productvariantid}
                                    selectVariant={selectVariant}
                                />
                            ))}
                        </div>
                        {setStyle === "pill" && (
                            <div className="pill-subscribe-action">
                                <button className="subscribe-btn" onClick={() => { if (selectedVariant) { addToBasket(selectedVariant); checkout(fid, true); } }} disabled={!selectedVariant}>Subscribe</button>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                /* Card group: all groups visible side by side */
                <div className="variant-groups-all">
                    {groups.map((group, groupIndex) => (
                        <div key={groupIndex} className="variant-group-column">
                            <h3 className="variant-group-column-title">{group.title}</h3>
                            <div className="variant-groups-image">
                                <img src={group.image} alt={group.title} />
                            </div>
                            <div className="variant-groups-features">
                                <h3>What's included</h3>
                                <ul>
                                    {group.features.map((feature, i) => (
                                        <li key={i}>{feature}</li>
                                    ))}
                                </ul>
                            </div>
                            <div className="variant-group-column-variants">
                                {group.variants.map((item, index) => (
                                    <Variant
                                        key={index}
                                        variant={item.productvariantid}
                                        price={item?.price}
                                        description={item?.productvariantname}
                                        title={item?.title}
                                        originalPrice={item?.originalPrice}
                                        priceFrequency={item?.priceFrequency}
                                        offerEndText={item?.offerEndText}
                                        shortDescription={item?.shortDescription}
                                        badge={item?.badge}
                                        highlighted={item?.highlighted}
                                        setStyle="pill"
                                        incrementQuantity={incrementQuantity}
                                        decreaseQuantity={decreaseQuantity}
                                        oneproductbuy={oneproductbuy}
                                        setQuantityForVariant={setQuantityForVariant}
                                        varQuantity={varQuantity[item.productvariantid] || 0}
                                        addToBasket={addToBasket}
                                        isMultiVariant={false}
                                        isMultiVariantDropdown={isMultiVariant}
                                        selected={selectedVariant === item.productvariantid}
                                        selectVariant={selectVariant}
                                    />
                                ))}
                            </div>
                            <div className="pill-subscribe-action">
                                <button className="subscribe-btn" onClick={() => { if (selectedVariant) { addToBasket(selectedVariant); checkout(fid, true); } }} disabled={!selectedVariant}>Subscribe</button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default VariantGroups;
